import { jsx } from "react/jsx-runtime";
const SocialLink = ({ link, icon: Icon, size = 18 })=>/*#__PURE__*/ jsx("a", {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "px-12 text-inherit",
        children: /*#__PURE__*/ jsx(Icon, {
            size: size,
            ignoreColor: true,
            className: "fill-current "
        })
    });
const BottomSection_SocialLink = SocialLink;
export default BottomSection_SocialLink;
